import React from 'react'
import './applicationTableDocumentsInfo.scss' 


const  ApplicationTableDocumentsInfo = ({ applicationData}) => {


const downloadImage = (url, defaultName = "document") => {
  if (!url) return;

  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      // 1. Detect the file extension automatically from the blob type
      let extension = "jpg"; // fallback extension
      
      if (blob.type === "application/pdf") {
        extension = "pdf";
      } else if (blob.type === "image/png") {
        extension = "png";
      } else if (blob.type === "image/jpeg" || blob.type === "image/jpg") {
        extension = "jpg";
      }

      // 2. Clean the provided file name so it doesn't have a duplicated or wrong extension
      const baseName = defaultName.split('.')[0];
      const finalFileName = `${baseName}.${extension}`;

      // 3. Create the object URL and trigger the native download
      const blobUrl = window.URL.createObjectURL(blob); 
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = finalFileName;
      
      document.body.appendChild(link);
      link.click();

      // 4. Memory Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch((error) => {
      console.error("Download failed:", error);
    });
};



//   const downloadImage = (url, fileName) => {
//     // Prevent execution if url is missing
//     if (!url) return;

//     fetch(url)
//       .then((response) => response.blob())
//       .then((blob) => {
//         // Create an object URL directly from the fetched blob
//         const blobUrl = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = blobUrl;
        
//         // Dynamically name the file based on the document type
//         link.download = fileName || "downloaded-file";
        
//         document.body.appendChild(link);
//         link.click();

//         // Cleanup DOM and memory
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(blobUrl);
//       })
//       .catch((error) => {
//         console.error("Error fetching the file:", error);
//       });
//   };

  


  return (
            
    <div className=''>

        
    <div className='item'>
        <div className="details">

        <h4 style={{fontSize:18, marginBottom:20}}>Available Documents</h4>

            {
                applicationData.internationalPassport === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', justifyContent:'space-between', marginBottom:20, alignItems:'center', gap:20}}>
                    <div style={{display:'flex', flexDirection:'row', gap:40}}>
                        <span style={{fontWeight:'bold', color:'#00000088'}}>International Passport:</span>
                        {/* <span className=''>{applicationData.internationalPassport}</span> */}
                    </div>
                    
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:40}}>
                    {/* <a href={applicationData.internationalPassportImage} download>View</a> */}
                    <a href={applicationData.internationalPassportImage} target="_blank" rel="noreferrer">View</a>
                    <button 
                    onClick={() => downloadImage(applicationData.internationalPassportImage, "international_passport")}
                    style={{ background: 'none', border: 'none', color: '#0066cc', cursor: 'pointer', padding: 0, textDecoration: 'underline' }}
                    >
                    Download
                    </button>
                    </div>
                  
                </div>
                :

                ""
            }  

         

                 {
                applicationData.passportPhotograph === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', justifyContent:'space-between', marginBottom:20, alignItems:'center', gap:20}}>
                    <div style={{display:'flex', flexDirection:'row', gap:40}}>
                        <span style={{fontWeight:'bold', color:'#00000088'}}>Passport Photograph:</span>
                        {/* <span className='itemValue'>{applicationData.passportPhotograph}</span> */}
                    </div>

                      <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:40}}>
                    <a href={applicationData.passportPhotographImage} target="_blank" rel="noreferrer">View</a>
                    <button 
                    onClick={() => downloadImage(applicationData.passportPhotographImage, "passport_photograph")}
                    style={{ background: 'none', border: 'none', color: '#0066cc', cursor: 'pointer', padding: 0, textDecoration: 'underline' }}
                    >
                    Download
                    </button>
                    </div>
           
                   
                </div>
                :

                ""
            }     

       

            {
                applicationData.birthCertificate  === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', justifyContent:'space-between', marginBottom:20, alignItems:'center', gap:20}}>
                <div style={{display:'flex', flexDirection:'row', gap:20}}>
                    <span style={{fontWeight:'bold', color:'#00000088'}}>Birth Certificate:</span>
                    <span className='itemValue'>{applicationData.birthCertificate }</span>
                </div>

                  <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:40}}>
                    <a href={applicationData.birthCertificate} target="_blank" rel="noreferrer">View</a>
                    <button 
                    onClick={() => downloadImage(applicationData.birthCertificate, "birthCertificate")}
                    style={{ background: 'none', border: 'none', color: '#0066cc', cursor: 'pointer', padding: 0, textDecoration: 'underline' }}
                    >
                    Download
                    </button>
                  </div>

                   
                </div>
                :

                ""
            }  

             

            {
                applicationData.marriageCertificate  === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', justifyContent:'space-between', marginBottom:20, alignItems:'center', gap:20}}>
                <div style={{display:'flex', flexDirection:'row', gap:40}}>
                    <span style={{fontWeight:'bold', color:'#00000088'}}>Marriage Certificate:</span>
                    {/* <span className='itemValue'>{applicationData.marriageCertificate}</span> */}
                </div>

                   <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:40}}>
                    <a href={applicationData.marriageCertificateImage} target="_blank" rel="noreferrer">View</a>
                    <button 
                    onClick={() => downloadImage(applicationData.marriageCertificateImage, "marriageCertificateImage")}
                    style={{ background: 'none', border: 'none', color: '#0066cc', cursor: 'pointer', padding: 0, textDecoration: 'underline' }}
                    >
                    Download
                    </button>
                  </div>

                   
                </div>
                :

                ""
            }  


           

            {
                applicationData.statementOfAccount  === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', justifyContent:'space-between', marginBottom:20, alignItems:'center', gap:20}}>
                <div style={{display:'flex', flexDirection:'row', gap:40}}>
                    <span style={{fontWeight:'bold', color:'#00000088'}}>Statement of Account:</span>
                    {/* <span className='itemValue'>{applicationData.statementOfAccount}</span> */}
                </div>

                  <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:40}}>
                    <a href={applicationData.statementOfAccountImage} target="_blank" rel="noreferrer">View</a>
                    <button 
                    onClick={() => downloadImage(applicationData.statementOfAccountImage, "statementOfAccountImage")}
                    style={{ background: 'none', border: 'none', color: '#0066cc', cursor: 'pointer', padding: 0, textDecoration: 'underline' }}
                    >
                    Download
                    </button>
                  </div>

               
                </div>
                :

                ""
            }  


            


            {
                applicationData.companyIntroduction  === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', justifyContent:'space-between', marginBottom:20, alignItems:'center', gap:20}}>
                <div style={{display:'flex', flexDirection:'row', gap:40}}>
                    <span style={{fontWeight:'bold', color:'#00000088'}}>Company Introduction Letter:</span>
                    {/* <span className='itemValue'>{applicationData.companyIntroduction}</span> */}
                </div>


                <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:40}}>
                    <a href={applicationData.companyIntroductionImage} target="_blank" rel="noreferrer">View</a>
                    <button 
                    onClick={() => downloadImage(applicationData.companyIntroductionImage, "companyIntroductionImage")}
                    style={{ background: 'none', border: 'none', color: '#0066cc', cursor: 'pointer', padding: 0, textDecoration: 'underline' }}
                    >
                    Download
                    </button>
                  </div>

                  
                   
                </div>
                :

                ""
            }  

           


            {
                applicationData.selfIntroduction  === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', justifyContent:'space-between', marginBottom:20, alignItems:'center', gap:20}}>
                <div style={{display:'flex', flexDirection:'row', gap:40}}>
                    <span style={{fontWeight:'bold', color:'#00000088'}}>Self Introduction Letter:</span>
                    {/* <span className='itemValue'>{applicationData.selfIntroduction}</span> */}
                </div>


                <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:40}}>
                    <a href={applicationData.selfIntroductionImage} target="_blank" rel="noreferrer">View</a>
                    <button 
                    onClick={() => downloadImage(applicationData.selfIntroductionImage, "selfIntroductionImage")}
                    style={{ background: 'none', border: 'none', color: '#0066cc', cursor: 'pointer', padding: 0, textDecoration: 'underline' }}
                    >
                    Download
                    </button>
                  </div>
                
                </div>
                :

                ""
            }  



            {
                applicationData.leaveApprovalLetter  === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', justifyContent:'space-between', marginBottom:20, alignItems:'center', gap:20}}>
                <div style={{display:'flex', flexDirection:'row', gap:40}}>
                    <span style={{fontWeight:'bold', color:'#00000088'}}>Leave Approval Letter:</span>
                    {/* <span className='itemValue'>{applicationData.leaveApprovalLetter}</span> */}
                </div>

                     <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:40}}>
                    <a href={applicationData.leaveApprovalLetterImage} target="_blank" rel="noreferrer">View</a>
                    <button 
                    onClick={() => downloadImage(applicationData.leaveApprovalLetterImage, "leaveApprovalLetterImage")}
                    style={{ background: 'none', border: 'none', color: '#0066cc', cursor: 'pointer', padding: 0, textDecoration: 'underline' }}
                    >
                    Download
                    </button>
                  </div>

                </div>
                :

                ""
            }  

             

{
                applicationData.employmentLetter  === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', justifyContent:'space-between', marginBottom:20, alignItems:'center', gap:20}}>
                <div style={{display:'flex', flexDirection:'row', gap:40}}>
                    <span style={{fontWeight:'bold', color:'#00000088'}}>Employment Letter:</span>
                    {/* <span className='itemValue'>{applicationData.employmentLetter}</span> */}
                </div>

                  <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:40}}>
                    <a href={applicationData.employmentLetterImage} target="_blank" rel="noreferrer">View</a>
                    <button 
                    onClick={() => downloadImage(applicationData.employmentLetterImage, "employmentLetterImage")}
                    style={{ background: 'none', border: 'none', color:  '#0066cc', cursor: 'pointer', padding: 0, textDecoration: 'underline' }}
                    >
                    Download
                    </button>
                  </div>

                </div>
                :

                ""
            }  
            
          
        
        </div>

    </div>  

    <div className='item'>     

        <div className="details">

        <h4>Unavailable Documents</h4>


            {
                applicationData.internationalPassport === "unavailable"
                ?
                <div className='detailItem'>
                    <span className='itemKey'>International Passport:</span>
                    <span className='itemValue'>{applicationData.internationalPassport}</span>
                </div>
                :

                ""
            }  

             {
                applicationData.passportPhotograph === "unavailable"
                ?
                <div className='detailItem'>
                    <span className='itemKey'>Passport Photograph:</span>
                    <span className='itemValue'>{applicationData.passportPhotograph}</span>
                </div>
                :

                ""
            }      

            {
                applicationData.birthCertificate === "unavailable"
                ?
                <div className='detailItem'>
                    <span className='itemKey'>Birth Certificate:</span>
                    <span className='itemValue'>{applicationData.birthCertificate}</span>
                </div>
                :

                ""
            }  

             {
                applicationData.marriageCertificate === "unavailable"
                ?
                <div className='detailItem'>
                    <span className='itemKey'>Marriage Certificate:</span>
                    <span className='itemValue'>{applicationData.marriageCertificate}</span>
                </div>
                :

                ""
            }  
              


              {
                applicationData.statementOfAccount === "unavailable"
                ?
                <div className='detailItem'>
                    <span className='itemKey'>Statement of Account:</span>
                    <span className='itemValue'>{applicationData.statementOfAccount}</span>
                </div>
                :

                ""
            }  

             {
                applicationData.companyIntroduction === "unavailable"
                ?
                <div className='detailItem'>
                    <span className='itemKey'>Company Introduction Letter:</span>
                    <span className='itemValue'>{applicationData.companyIntroduction}</span>
                </div>
                :

                ""
            }      

            {
                applicationData.selfIntroduction === "unavailable"
                ?
                <div className='detailItem'>
                    <span className='itemKey'>Self Introduction Letter:</span>
                    <span className='itemValue'>{applicationData.selfIntroduction}</span>
                </div>
                :

                ""
            }  

             {
                applicationData.leaveApprovalLetter === "unavailable"
                ?
                <div className='detailItem'>
                    <span className='itemKey'>Leave Approval Letter:</span>
                    <span className='itemValue'>{applicationData.leaveApprovalLetter}</span>
                </div>
                :

                ""
            }  
                
                {
                applicationData.employmentLetter === "unavailable"
                ?
                <div className='detailItem'>
                    <span className='itemKey'>Employment Letter:</span>
                    <span className='itemValue'>{applicationData.employmentLetter}</span>
                </div>
                :

                ""
            }  
            
          
        
        </div>

    </div>
    </div>
   
  );
}

export default ApplicationTableDocumentsInfo